import { cn } from "@repo/shared/utils";
import type { LaserficheInspectTag, LaserfichePutTag } from "@repo/types";
import { Chip } from "@repo/ui/components/Base/Chip";
import { useMemo } from "react";

export interface LaserficheTagPickerProps {
  disabled?: boolean;
  availableTags: LaserficheInspectTag[];
  className?: string;
  value?: LaserfichePutTag[];
  onChange?: (value: LaserfichePutTag[]) => void;
}

export const LaserficheTagPicker = ({
  disabled,
  availableTags,
  className,
  value = [],
  onChange,
}: LaserficheTagPickerProps) => {
  const idSet = useMemo(
    () =>
      value.reduce((set, tag) => (set.add(tag.tagId), set), new Set<number>()),
    [value]
  );

  return (
    <div className={cn("flex flex-row gap-2 flex-wrap", className)}>
      {!availableTags.length && <p>(Laserfiche has no tags.)</p>}

      {availableTags.map((tag) => (
        <Chip
          key={tag.id}
          title={tag.description}
          className={cn(!idSet.has(tag.id) && "bg-gray-400 hover:bg-gray-400")}
          onClick={
            disabled
              ? undefined
              : () => {
                  if (!onChange) return;

                  const isSelected = idSet.has(tag.id);
                  const newSelection: LaserfichePutTag[] = isSelected
                    ? value.filter(
                        (selectedTag) => selectedTag.tagId !== tag.id
                      ) // remove
                    : [...value, { tagId: tag.id }]; // add

                  onChange(newSelection);
                }
          }
        >
          {tag.name}
        </Chip>
      ))}
    </div>
  );
};
